/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import templateOnly from "@ember/component/template-only";
import { EmberChangeset } from "ember-changeset";
const MiciBaseEditionFormSummaryComponent = templateOnly(undefined, undefined);
export default MiciBaseEditionFormSummaryComponent;